import { render } from "./MomentView.vue?vue&type=template&id=07741452&scoped=true"
import script from "./MomentView.vue?vue&type=script&lang=js"
export * from "./MomentView.vue?vue&type=script&lang=js"

import "./MomentView.vue?vue&type=style&index=0&id=07741452&scoped=true&lang=css"

import exportComponent from "../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-07741452"]])

export default __exports__